import { ModuleWithProviders, NgModule } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { AppConfig } from "./classes/app-config.class";
import { TOKEN_APP_CONFIG } from "./models/constant";

@NgModule({
    imports: []
})
export class CommonLibModule {

    public static forRoot(config: Partial<AppConfig>): ModuleWithProviders<CommonLibModule> {
        return {
            ngModule: CommonLibModule,
            providers: [
                {
                    provide: TOKEN_APP_CONFIG,
                    useValue: new BehaviorSubject<Partial<AppConfig>>(config)
                }
            ]
        }
    }


}